import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {IonicModule, MenuController} from "@ionic/angular";
import {NavigationEnd, Router, RouterModule} from "@angular/router";
import {filter, take} from "rxjs";
import {StorageService} from "../../services/internals/storage.service";
import { ProcurationService } from 'src/app/services/repositories/procuration.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/repositories/auth.service';
import { GestionErreursService } from 'src/app/services/gestion-erreurs.service';
import { UserService } from 'src/app/services/repositories/user.service';
import { MatIconModule } from '@angular/material/icon';
import { InvitationService } from 'src/app/services/repositories/invitation.service';
import { Capacitor } from '@capacitor/core';
import { UserPhotoUrlPipe } from 'src/app/pipes/user-photo-url.pipe';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [CommonModule, IonicModule, RouterModule, TranslateModule, MatIconModule, UserPhotoUrlPipe],
  standalone: true
})
export class MenuComponent  implements OnInit {
  currentUrl: any;
  currentUser: any;
  comptesPartages: boolean = false;
  comptePartageEnCours: any;
  invitationsLength: any;

  constructor(
    private menu: MenuController,
    private storageService: StorageService,
    private ProcurationService: ProcurationService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
    private userService: UserService,
    private invitationService: InvitationService,
    private gestionErreursService: GestionErreursService
  ) {

  }

  async ngOnInit() {
    this.currentUser = await this.userService.getUserInStorage();
    this.userService.currentUserPhoto$.subscribe(photo => {
      this.currentUser = { ...this.currentUser, photo };
      this.cdRef.detectChanges();
    });
    if(this.currentUrl && this.currentUrl !== '/login' && this.currentUrl !== '/register' && this.currentUrl !== '/plan-de-salle') {
      this.getInvitations();
      this.ProcurationService.getProcurations().then(obs => {
        obs.pipe(take(1)).subscribe((res: any) => {
          this.comptesPartages = res.length > 0;
        });
      })
      this.authService.comptePartage$.subscribe(value => {
        this.comptePartageEnCours = value;
        this.cdRef.detectChanges(); // au cas où le changement vient d’un autre composant
      });
    }
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentUrl = this.router.url.split('?')[0];
      if(this.currentUrl && this.currentUrl !== '/login' && this.currentUrl !== '/register' && this.currentUrl !== '/plan-de-salle') {
        this.getInvitations();
      }
    });
  }

  getInvitations() {
    console.log(this.currentUrl)
    this.invitationsLength = 0;
    if(this.currentUser) {
      this.invitationService.findBy({user_id: this.currentUser.id}).then(req => {
        req.pipe(take(1)).subscribe((invitations: any) => {
          this.invitationsLength = invitations.length;
        });
      });
    }
  }

  closeMenu() {
    this.menu.close();
  }

  logout() {
    // Attendre que le menu se ferme avant de continuer
    this.menu.close().then(res => {
      this.authService.logout().then((req: any) => {
        req.pipe(take(1)).subscribe({
          next: (res: any) => {
            this.storageService.clearAll();
            this.router.navigate(['login']);
          }, 
          error: (err: any) => {
            this.gestionErreursService.handleError(err)
          }
        })
      })
    });
  }
}
